import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3473bce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-listing-page" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { WOrganizationSidebar } from '@/widgets/WOrganizationSidebar'
import { WOrganizationDetailSidebar } from '@/widgets/WOrganizationDetailSidebar'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const isOrganizationDetail = computed(() => route.path.includes('/show'))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isOrganizationDetail))
      ? (_openBlock(), _createBlock(_unref(WOrganizationSidebar), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(WOrganizationDetailSidebar), { key: 1 })),
    _createVNode(_component_router_view)
  ]))
}
}

})